import React from "react";
import { Link } from "@quintype/components";
import "./all-rankings.m.css";

export const ListView = ({ snapshotByRank, visibleItemsForList, rankingEntitySlug }) => {
  // Add tracking functionality for list item clicks
  let isTracking = false;
  const handleItemClick = (entityName, position) => {
    if (isTracking) return;
    isTracking = true;

    setTimeout(() => {
      isTracking = false;
    }, 300);

    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_ranking_detail_interactions",
        event_action: "profile_select",
        link_text: entityName.toLowerCase(),
        link_position: position,
        category: "rankings",
        sub_category: rankingEntitySlug || "NA",
        template_name: "rankdetail",
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
  <div styleName="tableContainer">
    <table styleName={`table ${rankingEntitySlug === "most-powerful-women" ? "mpw-table" : "forty-under-forty-table"}`}>
      <thead>
        <tr>
          {rankingEntitySlug === "most-powerful-women" && <th styleName="table-header">RANK</th>}
          <th styleName="table-header">NAME</th>
          <th styleName="table-header">TITLE</th>
          <th styleName="table-header">AFFILIATION</th>
          <th styleName="table-header">AGE</th>
        </tr>
      </thead>
      <tbody>
        {snapshotByRank.slice(0, visibleItemsForList).map((entityData, index) => (
          <tr key={index} styleName="row">
            {rankingEntitySlug === "most-powerful-women" && (
              <td styleName="cell bold-cell">{entityData?.["current-rank"]}</td>
            )}
            <td styleName="cell bold-cell">
              <Link
                href={`/people/${
                  entityData["most-powerful-women-snapshot-individual"]?.slug ||
                  entityData["forty-under-forty-snapshot-individual"]?.slug
                }`}
                onMouseDown={() => handleItemClick(entityData?.name, entityData?.["current-rank"] || index + 1)}
              >
                <strong>{entityData?.name}</strong>
              </Link>
            </td>
            <td styleName="cell">{entityData?.designation || "N/A"}</td>
            <td styleName="cell">{entityData?.company || "N/A"}</td>
            <td styleName="cell">{entityData?.age || "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  );
};
